import http from '@/utils/http';
const base_path = '/v2/tool/siteSet';

/**
 * 获取版位列表接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getSiteSetApi = (params) => {
  return http.get({
    url: base_path,
    params,
  });
};
